'use strict';
import angular from 'angular';

import facebookCreateAdsHtmlUrl from './views/facebookCreateAds.list.html';
import facebookCreativeLibHtmlUrl from './views/directive_creativeFb.html';

var app = angular.module('app.facebookCreateAdsComponent', []);

app.component('facebookCreateAds', {
    bindings: {
        facebookCreateAdsets: '=',
        showActions: "=",
        clientId: "=",
        clusterId: "="
    },
    templateUrl: facebookCreateAdsHtmlUrl,

    // The controller that handles our component logic
    controller: function ($scope, $ioAlert, anchorSmoothScroll, $location, $timeout, MediaService, creativesService, FormService, ModalService, OrdersService) {
        var self = this;
        self.adGroupFormObj = {};
        self.adGroup = [];
        let creativeId;
        self.fbAdTypeObj = { adType: "Single Image Ad", uploadedCreatives: [], creativeId, carouselData: []};
        self.carouselData = [{
            "headline": "",
            "description": "",
            "websiteUrl":"",
        }]
        self.adTypes = ["Single Image Ad", "Slideshow Ads","Single Video Ad", "Carousel"];
        self.actionList = ["No Action", "Buy Now", "Learn More", "Apply Now","Book Now","Buy Tickets","Call Now","Contact Us","Donate Now","Download","Get Directions","Get Offer","Get Quote","Get Showtimes","Install Now","Like Page","Listen Now","Open Link","Order Now","Play Game","Request Time","Save","See Menu","Send Message","Send WhatsApp Message","Shop Now","Sign Up","Subscribe","Use App","View Event","Watch More"];
        self.showFbAdGroupForm = false;
        self.showAdTypeForm = false;
        self.adGroupStatus = ["ENABLED", "PAUSED", "REMOVED"];
        self.groupSlides = [
            { "name": "adgroup" },
            { "name": "adtype" }
        ];
        self.isAdGroup = true;
        self.isAdType = false;
        self.trackingTemplateUrl = "";
        self.finalUrlSuffix = "";
        self.customParameters = [{
            "name": "",
            "value": ""
        }];
        self.isVideoLink = false;
        self.instagramAccounts = [];
        self.facebookAccounts = [];
        //Show AdType by Sliding to the AdType View
        self.viewAdType = function (facebookCreateAdsets) {
            self.facebookCreateAdsets = facebookCreateAdsets;
            self.isAdGroup = false;
            self.showFbAdGroupForm = false;
            self.isAdType = true;
            //If there are no Adds create an Empty Array
            if (!self.facebookCreateAdsets) {
                self.facebookCreateAdsets = [];
            };
            if (self.facebookCreateAdsets && self.facebookCreateAdsets.length == 0 && self.showActions) {
                self.addAdType();
            };
        };

        var getAttachedCreatives = function () {
            MediaService.getLineItemCreatives(OrdersService.lineItem.id).then(function () {
                if (MediaService.creatives && MediaService.creatives.length > 0) {
                    if (self.facebookCreateAdsets && self.facebookCreateAdsets.length > 0) {
                        var creativesData = angular.copy(MediaService.creatives);
                        _.each(self.facebookCreateAdsets, function (item) {
                            _.each(item.uploadedCreatives, function (image, index) {
                                var obj = creativesData.find(data => data.creative_id == image.id);
                                if (obj) {
                                    item.uploadedCreatives[index] = obj;

                                }
                            })
                        })
                    }
                }
            }, function () {
            });
        };

        /*
         * Update AdType Helper function to toggle Image Ad and expanded ad
         */
        self.updateAdType = function (type) {
            self.fbAdTypeObj = { adType: type, uploadedCreatives: [], actionType: "No Action" };
        };

        self.onFileSelect = function (files, errorFiles) {
            angular.forEach(files, function (file) {
                MediaService.saveClientCreative(self.clientId, file).then(function (response) {
                    $timeout(function () {
                        if (MediaService.creative) {
                            if (self.fbAdTypeObj.adType === 'Single Image Ad') {
                                self.fbAdTypeObj.uploadedCreatives = [];
                                self.fbAdTypeObj.uploadedCreatives.push(MediaService.creative);
                            } else {
                                self.fbAdTypeObj.uploadedCreatives.push(MediaService.creative);
                            }
                            $ioAlert.show('', 'File uploaded successfully.', 'success');
                        } else if (MediaService.errors) {
                            for (var x = 0; x < MediaService.errors.length; x++) {
                                var message = MediaService.errors[x];
                                $ioAlert.show("", "File upload error: " + message, 'error');
                            }
                        } else {
                            $ioAlert.show("Error!", "An error occurred uploading the file.", 'error');
                        }
                    });

                }, function () {
                    $ioAlert.show("Error!", "An error occurred uploading the file.", 'error');
                });
            });
        };

        self.addCreativeAdgroup = function (model, form) {
            if (self.clientId) {
                ModalService.returnModalType('creativeLibraryFb', self).result.then(function (formObj) {
                    if (self.fbAdTypeObj.adType == 'Single Image Ad' && self.fbAdTypeObj.uploadedCreatives.length > 0) {
                        self.previousImages =[];
                        self.previousImages = angular.copy(self.fbAdTypeObj.uploadedCreatives);
                    }
                    self.fbAdTypeObj.uploadedCreatives = formObj.selectedImages;
                    if (formObj.media && formObj.media.length > 0) {
                        self.onFileSelect(formObj.media);
                    }
                }, function (cancel) {
                    console.log("cancel");
                });
            } else {
                $ioAlert.show("Error", "Please select client");
            }
        };

        self.deleteFile = function (file, index,type) {
            if (file.creative_id) {
                MediaService.deleteCreative(file.id).then(function (response) {
                    if (MediaService.deletedId) {
                        self.fbAdTypeObj.uploadedCreatives.splice(index, 1);
                        if (self.fbAdTypeObj.carouselData) {
                            self.fbAdTypeObj.carouselData.splice(index, 1);
                        }
                        $ioAlert.show('', 'Image deleted Successfully', 'success');
                    }
                    else {
                        _.each(response.errors, function (err) {
                            $ioAlert.show("Error!", err, 'error');
                        })
                    }
                }, function () {
                    $ioAlert.show("Error!", "An error occurred uploading the file.", 'error');
                });
            } else {
                self.fbAdTypeObj.uploadedCreatives.splice(index, 1);
                if (self.fbAdTypeObj.carouselData) {
                    self.fbAdTypeObj.carouselData.splice(index, 1);
                }
                $ioAlert.show('', type +' '+'deleted Successfully', 'success');
            }
        }
        /*
         * Display Show AdType form
         */
        self.addAdType = function () {
            self.showAdTypeForm = true;
            self.isNewAd = true;
            self.fbAdTypeObj = { adType: "Single Image Ad", actionType: "No Action", uploadedCreatives: [], creativeId}
        };

        /*
         * Display Edit Ad Type form
         */
        self.editAdType = function (ad, index) {
            self.showAdTypeForm = true;
            self.fbAdTypeObj = angular.copy(ad);
            self.isNewAd = false;
            self.adIndex = index;
        }

        /*
         * Save/Edit Ad Type and update the AdGroup object
         */
        self.saveFbAdType = function (form) {
            var webSiteUrl = self.fbAdTypeObj.isEnterWebsiteUrl ? self.fbAdTypeObj.websiteUrl != undefined && self.fbAdTypeObj.websiteUrl != "" : true;
            var instagramPage = (typeof self.fbAdTypeObj.instagramPage !== 'undefined' && self.fbAdTypeObj.instagramPage !== '') ? self.fbAdTypeObj.instagramPage : false;
            var facebookPage = (typeof self.fbAdTypeObj.facebookPage !== 'undefined' && self.fbAdTypeObj.facebookPage !== '') ? self.fbAdTypeObj.facebookPage : false;
            var isEnterWebsiteUrl = (typeof self.fbAdTypeObj.isEnterWebsiteUrl !== 'undefined') ? self.fbAdTypeObj.isEnterWebsiteUrl : false;
            var primaryText = (typeof self.fbAdTypeObj.primaryText !== 'undefined' && self.fbAdTypeObj.primaryText !== '') ? self.fbAdTypeObj.primaryText : false;
            var webSiteUrls = true;
            if (self.fbAdTypeObj.adType != 'Carousel') {
                var headline = (typeof self.fbAdTypeObj.headline !== 'undefined' && self.fbAdTypeObj.headline !== '') ? self.fbAdTypeObj.headline : false;
                var description = (typeof self.fbAdTypeObj.description !== 'undefined' && self.fbAdTypeObj.description !== '') ? self.fbAdTypeObj.description : false;
            } else if (typeof self.fbAdTypeObj.carouselData !== 'undefined') {
                if (!Array.isArray(self.fbAdTypeObj.carouselData)) {
                    self.fbAdTypeObj.carouselData = Object.values(self.fbAdTypeObj.carouselData);
                    self.fbAdTypeObj.carouselData.forEach(function (data) {
                        if (data.websiteUrl == undefined || data.websiteUrl == '') {
                            webSiteUrls = false;
                        }
                    })
                }
            }
            if (form.name && form.name != "" && (form.uploadedCreatives.length > 0 || (form.existingVideo && form.existingVideo !== '') || (self.fbAdTypeObj.videoLink && self.fbAdTypeObj.videoLink != '')) && facebookPage && isEnterWebsiteUrl && webSiteUrl && ((headline && description) || (self.fbAdTypeObj.adType == 'Carousel' && webSiteUrls)) && primaryText) {
                if (self.isNewAd) {
                    self.facebookCreateAdsets.push(self.fbAdTypeObj);
                } else {
                    self.facebookCreateAdsets[self.adIndex] = self.fbAdTypeObj;
                }
                self.showAdTypeForm = false;
                if(self.fbAdTypeObj.adType == 'Single Image Ad' && self.previousImages && self.previousImages.length > 0){
                    if (self.previousImages[0].creative_id && self.previousImages[0].creative_id !== self.fbAdTypeObj.uploadedCreatives[0].id) {
                        MediaService.deleteCreative(self.previousImages[0].id);
                    }
                }
                if (self.fbAdTypeObj.creativeId == undefined) {
                    self.fbAdTypeObj.creativeId = Date.now();
                }
                self.fbAdTypeObj = { adType: "Single Image Ad", actionType: "No Action", uploadedCreatives: [], creativeId}
            } else {
                $ioAlert.show('Error:', 'Enter the mandatory fields', 'error');
            }
        }


        /*
         * Delete Ad Type
         */
        self.delAdType = function (index) {
            self.showAdTypeForm = false;
            self.facebookCreateAdsets.splice(index, 1);
        }

        /*
         * Cancel AdType form 
         */
        self.cancelFbAdType = function () {
            self.showAdTypeForm = false;
            self.fbAdTypeObj = { adType: "Single Image Ad", actionType: "No Action", uploadedCreatives: [] }
        }

        self.fetchInstagramAccounts = function () {
            self.fbAdTypeObj.facebookPage;
            FormService.fetchInstagramAccounts(self.clusterId, self.clientId,self.fbAdTypeObj.facebookPage).then(function () {
                if (FormService.instagramAccounts) {
                    self.instagramAccounts = FormService.instagramAccounts;
                }
            }, function () {
                console.log("Error while fetching instagram accounts !");
            });
        }

        self.fetchFacebookAccounts = function () {
            FormService.fetchFacebookAccounts(self.clusterId, self.clientId).then(function () {
                if (FormService.facebookAccounts) {
                    self.facebookAccounts = FormService.facebookAccounts;
                }
            }, function () {
                console.log("Error while fetching facebook accounts !");
            });
        }

        self.onVideoSelect = function(file){
            if(self.fbAdTypeObj.existingVideo && self.fbAdTypeObj.existingVideo !== ""){
                self.fbAdTypeObj.uploadedCreatives.splice(file,1);
                $ioAlert.show('Error:','Existing video already selected. Please remove the selected file to use uploaded video creative.', 'error');
            } else{
                if(file && file.length > 0){
                    var data = file;
                    const toBase64 = file => new Promise((resolve, reject) => {
                        const reader = new FileReader();
                        reader.readAsDataURL(file);
                        reader.onload = () => resolve(reader.result);
                        reader.onerror = error => reject(error);
                    });
                    
                    async function Main() {
                        file[0].encoded_string = await toBase64(file[0]);
                    }
                    Main();
                }
            }
        }

        self.onSelectUploadedVideo = function () {
            if (self.isVideoLink) {
                if (self.fbAdTypeObj.videoLink && self.fbAdTypeObj.videoLink != '') {
                    self.fbAdTypeObj.existingVideo = "";
                    $ioAlert.show('Error:', 'Video URL selected for upload. Please remove the URL to use existing video creative', 'error');
                }
            } else {
                if (self.fbAdTypeObj.uploadedCreatives && self.fbAdTypeObj.uploadedCreatives.length > 0) {
                    self.fbAdTypeObj.existingVideo = "";
                    $ioAlert.show('Error:', 'Video file selected for upload. Please remove the selected file to use existing video creative.', 'error');
                }
            }
        }

        self.fetchFacebookVideos = function(){
            FormService.fetchFacebookVideos(self.clusterId, self.clientId).then(function () {
                var filterObj=[];
                if (FormService.fbUploadedVideos.length > 0) {
                    self.facebookUploadedVideos = FormService.fbUploadedVideos;
                }
            }, function () {
                console.log("Error while fetching facebook videos !");
            });
        }

        /* 
         * Initialize the component hide the add/edit operations based on showActions boolean value
         */
        self.initComponent = function () {
            if (self.facebookCreateAdsets) {
                self.facebookCreateAdsets = JSON.parse(self.facebookCreateAdsets);
                getAttachedCreatives();
            } else if (self.showActions) {
                self.facebookCreateAdsets = [];
                self.addAdType();
            }
            self.fetchInstagramAccounts();
            self.fetchFacebookAccounts();
            self.fetchFacebookVideos();
        };

        self.initComponent();
    }
}).directive('creativeLibraryFacebook', ["creativesService", "ClusterService", '$ioAlert', 'ModalService', 'MediaService', 'Upload', '$rootScope', '$state', function (creativesService, ClusterService, $ioAlert, ModalService, MediaService, Upload, $rs, $state) {
    return {
        restrict: 'A',
        templateUrl: facebookCreativeLibHtmlUrl,
        scope: {
            "selectedCreatives": "=",
            "clientId": "=",
            "returnModal": "=",
            "isMultiple": "=",
            "uploadMedia": "="
        },
        link: function (scope, element, attr) {
            scope.isSelected = false;
            scope.selectedCreatives = [];
            scope.addLibrary = false;
            scope.islibrary = false;
            scope.creatives = [];
            scope.isLoading = false;
            scope.noMedia = false;
            scope.page = 1;
            var currentPage;
            var acceptFormats = ['png', 'jpeg', 'jpg'];
            scope.showAddTolibrary = false;
            scope.showDisclaimerText = false;
            scope.indexArr = [];

            /*
             *  Delete file
             */
            scope.deleteFile = function (fileModal, index) {
                fileModal = fileModal.splice(index, 1);
            }

            scope.updateSelected = function (creative, isEdit) {
                if (scope.validFormat(creative)) {
                    scope.showDisclaimerText = false;
                    var index = scope.selectedCreatives.indexOf(creative);
                    if (index >= 0 && !isEdit) {
                        scope.selectedCreatives.splice(index, 1);
                        if (scope.selectedCreatives.length == 0) {
                            scope.isSelected = false;
                        } else {
                            scope.isSelected = true;
                        }
                    } else {
                        if (!scope.isMultiple) {
                            scope.selectedCreatives = [];
                        }
                        scope.isSelected = true;
                        scope.selectedCreatives.push(creative);
                    }
                } else {
                    scope.showDisclaimerText = true;
                }
            };

            scope.validFormat = function (image) {
                return acceptFormats.indexOf(image.format) !== -1;
            }

            scope.getCreatives = function () {
                if (scope.isLoading || currentPage == scope.page) {
                    return;
                }
                if (currentPage == 0) {
                    scope.creatives = [];
                }
                currentPage = scope.page;
                scope.isLoading = true;
                var params = {};
                params = {
                    "clientId": scope.clientId,
                    "thumbWidth": 200,
                    "perPage": 10,
                    "page": scope.page

                };
                creativesService.getCreativesForClient(params).then(function (success) {
                    scope.creatives = scope.creatives.concat(success.creatives);
                    if (scope.returnModal) {
                        for (var i = 0, len = scope.returnModal.length; i < len; i++) {
                            for (var j = 0, size = scope.creatives.length; j < size; j++) {
                                if (scope.returnModal[i].creative_id) {
                                    if (scope.returnModal[i].creative_id == scope.creatives[j].id && scope.indexArr.indexOf(scope.creatives[j].id) == -1) {
                                        scope.indexArr.push(scope.creatives[j].id)
                                        scope.updateSelected(scope.creatives[j], true);
                                    }
                                } else {
                                    if (scope.returnModal[i].id == scope.creatives[j].id && scope.indexArr.indexOf(scope.creatives[j].id) == -1) {
                                        scope.indexArr.push(scope.creatives[j].id)
                                        scope.updateSelected(scope.creatives[j], true);
                                    }
                                }
                            }
                        }
                    }
                    scope.isLoading = false;
                    if (success.creatives.length) {
                        scope.page = scope.page + 1;
                    }
                    if (scope.creatives.length) {
                        scope.noMedia = false;
                    } else {
                        scope.noMedia = true;
                    }
                    scope.isLoading = false;
                }, function (error) {
                    $ioAlert.show('Error!', 'Could not get Creatives.', 'error');
                });

            };


            var init = function () {
                if (scope.returnModal) {
                    //scope.uploadMedia.images = scope.returnModal.media;
                    //scope.upload(scope.uploadMedia.images);
                    //scope.selectedCreatives = scope.returnModal;
                }
            }
            init();
        }
    }
}]);